import PropTypes from 'prop-types';
import React from 'react';
import { Form } from 'react-bootstrap';

export class LoadingControl extends React.Component {
  state = {
    isLoading: false,
  };

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  handleOnKeyDown = async (event) => {
    if (event.key === 'Enter' && event.shiftKey === false) {
      event.preventDefault();

      const { onKeyDown, onValidation } = this.props;

      if (onValidation()) {
        this.setState({ isLoading: true });
        try {
          await onKeyDown();
        } finally {
          if (this._isMounted) this.setState({ isLoading: false });
        }
      }
    }
  };

  render() {
    const {
      type, placeHolder, name,
    } = this.props;
    const { isLoading } = this.state;

    return (
      <Form.Control
        required
        type={type}
        placeholder={placeHolder}
        name={name}
        onKeyDown={this.handleOnKeyDown}
        disabled={isLoading}
      />
    );
  }
}

LoadingControl.defaultProps = {
  onKeyDown: () => new Promise((_resolve, _reject) => {}),
  onValidation: () => true,
};

LoadingControl.propTypes = {
  type: PropTypes.string.isRequired,
  placeHolder: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onKeyDown: PropTypes.func,
  onValidation: PropTypes.func,
};

export default LoadingControl;
